import { DelimitedToken } from './delimited-token'
import { Tokenizer, TokenKind } from '../parser'
import type { NormalizedFullOptions } from '../liquid-options'

export class TagToken extends DelimitedToken {
  public name: string
  public tokenizer: Tokenizer
  public readonly args: string;
  public constructor (
    input: string,
    begin: number,
    end: number,
    options: NormalizedFullOptions,
    file?: string
  ) {
    const { trimTagLeft, trimTagRight, tagDelimiterLeft, tagDelimiterRight } = options
    const [valueBegin, valueEnd] = [begin + tagDelimiterLeft.length, end - tagDelimiterRight.length]
    super(TokenKind.Tag, [valueBegin, valueEnd], input, begin, end, trimTagLeft, trimTagRight, file)

    this.tokenizer = new Tokenizer(input, options.operators, file, this.contentRange, options.groupedExpressions)
    this.name = this.tokenizer.readTagName()
    this.tokenizer.assert(this.name, `illegal tag syntax, tag name expected`)
    this.tokenizer.skipBlank()
    this.args = this.tokenizer.input.slice(this.tokenizer.p, this.contentRange[1])
  }
}
